import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"search\"><path fill=\"currentColor\" d=\"M19.52 17.8a10.82 10.82 0 0 0 2.4-6.8 11 11 0 1 0-11 11 10.82 10.82 0 0 0 6.84-2.4l4.52 4.4L24 22.28zM17 17a8.52 8.52 0 1 1 2.5-6 8.47 8.47 0 0 1-2.5 6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol